import React, { useEffect, useState } from "react";
import { Formik, Form, Field, FieldArray, FastField } from "formik";
import { MdOutlineRemoveCircle } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import {getAuthorization} from "../../../axios/AxiosAut";
import Itemsdata from "./table/Itemsdata";
import Pickitemsdata from "./table/Pickitemsdata";
import BOM from "./BOM/BOM";

export default function EditUserForm() {
  const [Users, setUsers] = useState([
    {
      full_name: "",
    },
  ]);
  const [Customers, setCustomers] = useState([
    {
      name:"",
    }
  ])

  const UserRemoveTemplateHandler = (remove, index) => {
    remove(index);
  };
  const UserAddTemplateHandler = (push) => {
    push({
      name: "",
      job_role: "",
      phone_number: "",
      email: "",
    });
  };

  //Get Company Employees
  const getUsers =()=>{
    getAuthorization()
    .get("company/company_employees/")
    .then((res) => {
      setUsers(res.data);
    })
    .catch((err) => {
      console.log("Error in getting users", err);
    });
  }

  //Get all customers
  const getCustomers =()=>{
    
    getAuthorization()
    .get("company/all_customers/")
    .then((res) => {
      setCustomers(res.data);
    })
    .catch((err) => {
      console.log("Error in getting customers", err);
    });
  }

  useEffect(() => {
    getUsers()
    getCustomers()
  }, []);

  return (
    <>
      <div className="flex flex-row mt-9 mb-7 space-x-1">
                  <svg
                    className="mt-2"
                    width="28"
                    height="2"
                    viewBox="0 0 32 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M0 1H31.5" stroke="#1F78B4" />
                  </svg>

                  <p className="font-Montserrat font-medium text-blue-100 text-sm">
                    General
                  </p>
                </div>
                <div className="grid space-y-8">
                  <FastField name="name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="Name"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                  <Field name="staff.id">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <select
                        className="font-Montserrat border-2 border-solid border-gray
                        focus:border-blue-100 focus:outline-none text-gray-50 font-semibold mr-3  bg-default relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-left inline-flex items-center"
                         {...field}
                      >
                        <option value="" selected>Select User</option>
                        {Users.map((users, index) => (
                          <option
                            className=" text-gray-50 font-semibold mr-3  bg-default relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-left inline-flex items-center"
                            key={index}
                            value={users.id}
                          >
                            {users.full_name}
                          </option>
                        ))}
                      </select>
                        </>
                      );
                    }}
                  </Field>
                  <Field name="type">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                           <select
                        className="font-Montserrat border-2 border-solid border-gray
                        focus:border-blue-100 focus:outline-none text-gray-50 font-semibold mr-3  bg-default relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-left inline-flex items-center"
                         {...field}
                      >
                        <option value="" selected>Select Type</option>
                        <option
                            className=" text-gray-50 font-semibold mr-3  bg-default relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-left inline-flex items-center"
                            value="issues"
                          >
                            Issues
                          </option>
                          <option
                            className=" text-gray-50 font-semibold mr-3  bg-default relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-left inline-flex items-center"
                            value="order"
                          >
                            Order                         
                           </option>
                            <option
                            className=" text-gray-50 font-semibold mr-3  bg-default relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-left inline-flex items-center"
                            value="training"
                          >
                            Training                          
                            </option>
  
                      </select>
                        </>
                      );
                    }}
                  </Field>
                  <div className="flex flex-row space-x-1">
                    <svg
                      className="mt-2"
                      width="28"
                      height="2"
                      viewBox="0 0 32 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1H31.5" stroke="#1F78B4" />
                    </svg>

                    <p className="font-Montserrat font-medium text-blue-100 text-sm">
                      Scheduling
                    </p>
                  </div>
                  <FastField name="start_date">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="date"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-2 bg-default rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-2 bg-default rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="Start Date"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                  <FastField name="start_time">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="time"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="Start Time"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                  <FastField name="end_date">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="date"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-2 bg-default rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-2 bg-default rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="End Date"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                  <FastField name="end_time">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="time"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="End Time"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                  <FastField name="quantity">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="Quantity"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                  <FastField name="delivery_date">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="date"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-2 bg-default rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-2 bg-default rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="Delivery Date"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                  <div className="flex flex-row space-x-1">
                    <svg
                      className="mt-2"
                      width="28"
                      height="2"
                      viewBox="0 0 32 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1H31.5" stroke="#1F78B4" />
                    </svg>

                    <p className="font-Montserrat font-medium text-blue-100 text-sm">
                      Customer
                    </p>
                  </div>
                  <Field name="customer">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                            <select
                        className="font-Montserrat border-2 border-solid border-gray
                        focus:border-blue-100 focus:outline-none text-gray-50 font-semibold mr-3  bg-default relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-left inline-flex items-center"
                         {...field}
                      >
                        <option value="" selected>Select Customer</option>
                       {Customers.map((customers, index) => (
                          <option
                            className=" text-gray-50 font-semibold mr-3  bg-default relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-left inline-flex items-center"
                            key={index}
                            value={customers.id}
                          >
                            {customers.name}
                          </option>
                        ))}
                      </select>
                        </>
                      );
                    }}
                  </Field>
                  {/* <FieldArray name="customer">
                    {(FieldArrayProps) => {
                      const { push, remove, form } = FieldArrayProps;
                      const { values } = form;
                      const { contacts } = values;
                      return (
                        <>
                          <div className="flex flex-row mt-3 space-x-2">
                            <button
                              type="button"
                              onClick={() => UserAddTemplateHandler(push)}
                            >
                              <svg
                                width="25"
                                height="25"
                                viewBox="0 0 25 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle
                                  cx="12.5"
                                  cy="12.5"
                                  r="12.5"
                                  fill="#1F78B4"
                                />
                                <path
                                  d="M6.66406 12.5013H18.3307M12.4974 6.66797V12.5013V18.3346"
                                  stroke="white"
                                  stroke-width="1.66667"
                                />
                              </svg>
                            </button>
                            <p className="text-blue-200">Add Customers</p>
                          </div>
                          {contacts.map((contacts, index) => (
                            <>
                              {/* <div className="flex flex-col"> */}
                              {/* <div className="flex w-3/4 flex-row justify-between space-x-5">
                                <FastField name={`contacts.${[index]}.name`}>
                                  {(props) => {
                                    const { field, form, meta } = props;
                                    return (
                                      <>
                                        <input
                                          {...field}
                                          {...(meta.touched && meta.error
                                            ? {
                                                className:
                                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                              }
                                            : {
                                                className:
                                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                              })}
                                          type="text"
                                          id="name"
                                          placeholder="Name"
                                          value={
                                            values.contacts[index].name === null ||
                                            values.contacts[index].name ===
                                              undefined
                                              ? ""
                                              : values.contacts[index].name
                                          }
                                        ></input>
                                        {meta.touched && meta.error ? (
                                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                                            <span className="ml-1">
                                              {meta.error}
                                            </span>
                                          </label>
                                        ) : null}
                                      </>
                                    );
                                  }}
                                </FastField>
                                <FastField name={`contacts.${[index]}.job_role`}>
                                  {(props) => {
                                    const { field, form, meta } = props;
                                    return (
                                      <>
                                        <input
                                          {...field}
                                          {...(meta.touched && meta.error
                                            ? {
                                                className:
                                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                              }
                                            : {
                                                className:
                                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                              })}
                                          type="text"
                                          id="job_role"
                                          placeholder="Job Role"
                                          value={
                                            values.contacts[index].job_role ===
                                              null ||
                                            values.contacts[index].job_role ===
                                              undefined
                                              ? ""
                                              : values.contacts[index].job_role
                                          }
                                        ></input>
                                        {meta.touched && meta.error ? (
                                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                                            <span className="ml-1">
                                              {meta.error}
                                            </span>
                                          </label>
                                        ) : null}
                                      </>
                                    );
                                  }}
                                </FastField>
                              </div>
                              <div className="flex w-3/4 flex-row justify-between space-x-5">
                                <FastField
                                  name={`contacts.${[index]}.phone_number`}
                                >
                                  {(props) => {
                                    const { field, form, meta } = props;
                                    return (
                                      <>
                                        <input
                                          {...field}
                                          {...(meta.touched && meta.error
                                            ? {
                                                className:
                                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                              }
                                            : {
                                                className:
                                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                              })}
                                          type="text"
                                          id="phone_number"
                                          placeholder="Phone Number"
                                          value={
                                            values.contacts[index].phone_number ===
                                              null ||
                                            values.contacts[index].phone_number ===
                                              undefined
                                              ? ""
                                              : values.contacts[index].phone_number
                                          }
                                        ></input>
                                      </>
                                    );
                                  }}
                                </FastField>
                                <FastField name={`contacts.${[index]}.email`}>
                                  {(props) => {
                                    const { field, form, meta } = props;
                                    return (
                                      <>
                                        <input
                                          {...field}
                                          {...(meta.touched && meta.error
                                            ? {
                                                className:
                                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                              }
                                            : {
                                                className:
                                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                              })}
                                          type="text"
                                          id="email"
                                          placeholder="Email"
                                          value={
                                            values.contacts[index].email === null ||
                                            values.contacts[index].email ===
                                              undefined
                                              ? ""
                                              : values.contacts[index].email
                                          }
                                        ></input>
                                        {meta.touched && meta.error ? (
                                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                                            <span className="ml-1">
                                              {meta.error}
                                            </span>
                                          </label>
                                        ) : null}
                                      </>
                                    );
                                  }}
                                </FastField>
                              </div>
                              <div className="flex flex-row mt-3 space-x-2">
                                <button
                                  type="button"
                                  onClick={() =>
                                    UserRemoveTemplateHandler(remove, index)
                                  }
                                >
                                  <MdOutlineRemoveCircle
                                    size={27}
                                    color="#B91C1C"
                                  />
                                </button>
                                <p className="text-red-700">Remove Contact</p>
                              </div>
                            </>
                          ))}
                        </>
                      );
                    }}
                  </FieldArray> */} 
                </div>
                <div className="flex flex-row mt-8 ml-8 space-x-1">
              <svg
                className="mt-2"
                width="28"
                height="2"
                viewBox="0 0 32 2"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 1H31.5" stroke="#1F78B4" />
              </svg>

              <p className="font-Montserrat font-medium text-blue-100 text-sm">
                List Items
              </p>
            </div>
            <div className="flex flex-wrap justify-center">
              <div
                className="tabelcontainer flex-auto mt-2 overflow-auto mx-4"
              >
                <Itemsdata />
              </div>
            </div>
<BOM/>
            <div className="text-center w-fit align-middle m-auto text-blue-400 cursor-pointer pb-2">
              {" "}
              <button
                type="button"
                className="text-blue-900  bg-white border shadow-md  font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
              >
                <svg
                  width="26"
                  height="28"
                  viewBox="0 0 26 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.439 2L13.3563 15.5L1.71945 2"
                    stroke="#1F78B4"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
            <div className="flex flex-wrap justify-center">
              <div
                className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
              >
                <Pickitemsdata />
              </div>
            </div>
            <div className="grid mt-8 space-y-8">
                  <div className="flex flex-row space-x-1">
                    <svg
                      className="mt-2"
                      width="28"
                      height="2"
                      viewBox="0 0 32 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1H31.5" stroke="#1F78B4" />
                    </svg>

                    <p className="font-Montserrat font-medium text-blue-100 text-sm">
                      Picking
                    </p>
                  </div>
                  <FastField name="name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <div className="flex">
                          <input
                            type="checkbox"
                            className="border-2 w-fit bg-default rounded-md  py-2.5 font-medium relative block px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat"
                          ></input>
                          <label className="text-sm font-Montserrat text-blue-200">
                            <span className="ml-1">
                              Automatically create Picking list
                            </span>
                          </label>
                        </div>
                      );
                    }}
                  </FastField>
                  <FastField name="name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-2 bg-default rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-2 bg-default rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="Pick Date"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                  <FastField name="name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="time"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="Start Time"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                  <div className="flex flex-row space-x-1">
                    <svg
                      className="mt-2"
                      width="28"
                      height="2"
                      viewBox="0 0 32 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1H31.5" stroke="#1F78B4" />
                    </svg>

                    <p className="font-Montserrat font-medium text-blue-100 text-sm">
                      Packing
                    </p>
                  </div>
                  <FastField name="name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <div className="flex">
                          <input
                            type="checkbox"
                            className="border-2 w-fit bg-default rounded-md  py-2.5 font-medium relative block px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat"
                            placeholder="Delivery Date"
                          ></input>
                          <label className="text-sm font-Montserrat text-blue-200">
                            <span className="ml-1">
                              Automatically create Packing list
                            </span>
                          </label>
                        </div>
                      );
                    }}
                  </FastField>
                  <FastField name="name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-2 bg-default rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-2 bg-default rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="Pack Date"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                  <FastField name="name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="time"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                                }
                              : {
                                  className:
                                    "border-b-2 bg-default font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                                })}
                            placeholder="Start Time"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </FastField>
                </div>
         </>
  );
}
